import React from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const REPORT_CARDS = [
  {
    title: "AUM Reports",
    description: "Bifurcation of AUM across all AMC, Scheme, Category, RM, ARN",
    icon: "fa-chart-bar",
    color: "#10b981",
  },
  {
    title: "Cash Flow",
    description: "Analysis of Inflow & Outflow of investments across AMC, RM, Clients",
    icon: "fa-exchange-alt",
    color: "#ea580c",
  },
  {
    title: "Security Exposure",
    description: "All your clients exposure to any holding",
    icon: "fa-lock",
    color: "#7c3aed",
  },
  {
    title: "AUM Growth Report",
    description: "Market impact on AUM across all AMC's within a given time period",
    icon: "fa-chart-line",
    color: "#0ea5e9",
  },
  {
    title: "Variance in Allocation",
    description: "Difference in target and current allocation in clients portfolio",
    icon: "fa-chart-pie",
    color: "#f59e0b",
  },
  {
    title: "Inactive Clients",
    description: "List of clients who did not transact in a given time period",
    icon: "fa-user-slash",
    color: "#10b981",
  },
  {
    title: "ELSS Procurement Report",
    description: "List of clients who have invested in ELSS schemes in last three years",
    icon: "fa-file-search",
    color: "#ea580c",
  },
  {
    title: "Cross Sell Report",
    description: "Client wise AUM across all asset classes",
    icon: "fa-project-diagram",
    color: "#10b981",
  },
  {
    title: "Direct Vs Regular Savings",
    description: "Savings achieved with Direct or Potential savings if switched to Direct",
    icon: "fa-arrows-alt-h",
    color: "#7c3aed",
  },
  {
    title: "AMFI Due Diligence",
    description: "Due diligence stats for AMFI questionnaire",
    icon: "fa-file-alt",
    color: "#0ea5e9",
  },
  {
    title: "SIP Mining",
    description: "Running, New, Terminated or Matured SIPs across all your clients",
    icon: "fa-chart-area",
    color: "#7c3aed",
  },
  {
    title: "Alert Reports",
    description: "SIP upcoming, FMP maturity, FD maturity, Insurance renewal, Upcoming Birthdays, Upcoming Anniversaries, Portfolio review and Minor to Major alerts",
    icon: "fa-bell",
    color: "#f59e0b",
  },
  {
    title: "Change of Broker",
    description: "List of transactions received via change of broker",
    icon: "fa-user-tag",
    color: "#10b981",
  },
  {
    title: "SIP Business Report",
    description: "Net change in the SIP across all AMC that has been invested by clients",
    icon: "fa-search-dollar",
    color: "#7c3aed",
  },
  {
    title: "Redemption Simulation",
    description: "Current value and return provided by schemes if no Sell occurred in client's portfolio",
    icon: "fa-coins",
    color: "#ea580c",
  },
  {
    title: "Missing SIP",
    description: "Currently running SIPs for which no transaction has been done in given time period",
    icon: "fa-question-circle",
    color: "#7c3aed",
  },
  {
    title: "SIP Procurement Report",
    description: "Difference in SIP amount received in 2 time period. Used to find missing SIP",
    icon: "fa-calculator",
    color: "#0ea5e9",
  },
  {
    title: "Client Acquisition Report",
    description: "New Clients acquired in a given period of source",
    icon: "fa-user-plus",
    color: "#f59e0b",
  },
  {
    title: "Switch Out without Switch In",
    description: "Track change of Broker out in Switch Out",
    icon: "fa-random",
    color: "#ea580c",
  },
  {
    title: "Transaction Confirmation Mail",
    description: "Send Transaction confirmation mail to your clients",
    icon: "fa-envelope",
    color: "#10b981",
  },
];

function ReportCard({ title, description, icon, color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "16px",
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        transition: "box-shadow 0.2s, border-color 0.2s",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.12)";
        e.currentTarget.style.borderColor = teal;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
        e.currentTarget.style.borderColor = "#e2e8f0";
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          minWidth: 48,
          borderRadius: "50%",
          background: color,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
        }}
      >
        <i className={`fa-solid ${icon}`} aria-hidden />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h6 className="mb-1" style={{ fontWeight: 700, color: "#0f172a", fontSize: "15px" }}>
          {title}
        </h6>
        <p className="mb-0" style={{ fontSize: "13px", color: "#64748b", lineHeight: 1.5 }}>
          {description}
        </p>
      </div>
    </div>
  );
}

export default function AdminBusinessAnalytics() {
  return (
    <div className="main-content">
      <style>{`
        .business-analytics-grid {
          grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 768px) {
          .business-analytics-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Business Analytics</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Business Analytics
                </li>
              </ol>
            </nav>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
            }}
            className="business-analytics-grid"
          >
            {REPORT_CARDS.map((report) => (
              <ReportCard
                  title={report.title}
                  description={report.description}
                  icon={report.icon}
                  color={report.color}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
